export const PASSENGER_MAPPING_WARNING = '선택한 탑승 인원과 요금 응답의 승객 정보가 일치하지 않아 승객 번호로 표시합니다. 예약 전 인원 정보를 확인해 주세요.';

const TYPES = ['adults', 'children'];
const countValue = value => value === null || value === undefined || value === ''
  ? null : Number(value);
const validCount = value => Number.isInteger(value) && value >= 0;
const readCounts = source => {
  const values = TYPES.map(type => countValue(source?.[type]));
  return values.every(validCount) && values[0] + values[1] > 0
    ? { adults: values[0], children: values[1] } : null;
};

// Passenger identity is the request's numbered adult-then-child sequence, never
// the order in which a price category happens to list its guestno values.
export function resolveTraveltekPassengers({ counts, criteria, cruiseDetail, childAges = [], paxFareInfo } = {}) {
  const selected = readCounts(counts);
  const resolved = selected || readCounts(cruiseDetail) || readCounts(criteria);
  const expected = [];
  if (resolved) TYPES.forEach(type => {
    for (let i = 0; i < resolved[type]; i++) {
      expected.push({ guestNo: expected.length + 1, type, typeIndex: i + 1,
        ...(type === 'children' ? { age: childAges[i] ?? null } : {}) });
    }
  });

  let mismatch = false;
  if (resolved) [counts, cruiseDetail, criteria].filter(Boolean).forEach(source => {
    TYPES.forEach(type => {
      const value = countValue(source[type]);
      if (value !== null && (!validCount(value) || value !== resolved[type])) mismatch = true;
    });
    // Do not silently classify additional passenger categories as adults.
    ['teens', 'infants'].forEach(type => {
      const value = countValue(source[type]);
      if (value !== null && value !== 0) mismatch = true;
    });
  });

  const perPerson = cruiseDetail?.perperson;
  const rawIds = Array.isArray(perPerson)
    ? perPerson.flatMap(category => Array.isArray(category?.prices) ? category.prices.map(price => price?.guestno) : [])
    : (Array.isArray(paxFareInfo) ? paxFareInfo.map(pax => pax?.pax_idx) : []);
  const ids = [...new Set(rawIds.map(Number).filter(id => Number.isInteger(id) && id > 0))].sort((a, b) => a - b);
  if (rawIds.some(id => !Number.isInteger(Number(id)) || Number(id) <= 0)) mismatch = true;
  if (resolved && ids.length && (ids.length !== expected.length || ids.some((id, index) => id !== index + 1))) mismatch = true;

  if (resolved && !mismatch) return { passengers: expected, warning: '' };
  // Preserve actual guest numbers and prices, but don't invent an age category.
  const fallbackIds = ids.length ? ids : expected.map(pax => pax.guestNo);
  return {
    passengers: fallbackIds.map(guestNo => ({ guestNo, type: 'unknown', typeIndex: guestNo })),
    warning: fallbackIds.length || mismatch ? PASSENGER_MAPPING_WARNING : '',
  };
}
